import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ResumeType } from 'src/app/enums/resume-type';
import { CarouselComponent } from 'src/app/layouts/carousel/carousel.component';
import { Resume } from 'src/app/models/resume/resume';
import { ResumeService } from 'src/app/services/resume.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-my-cvcandidates',
    templateUrl: './my-cvcandidates.component.html',
    styles: [`
      .list-container 
      {
        max-height: 500px;
        overflow-y: auto;
      }`
    ],
    standalone: true,
    imports: [CarouselComponent, CommonModule, RouterLink]
})
export class MyCVCandidatesComponent implements OnInit {
  private readonly resumeService = inject(ResumeService);
  private readonly router = inject(Router);
  
  public resumes = signal<Resume[]>([]);
  public resumeType = ResumeType;
 
  constructor() { }

  ngOnInit(): void {
    this.getResumes();
  }

  getResumes(){
    this.resumeService.getResumes().subscribe({
      next: res => {
        this.resumes.set(res);
      }
    });
  }

  deleteCv(resumeId: number): void {
    Swal.fire({
      title: 'Eliminar',
      text: '¿Desea eliminar el curriculum?',
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: '#0d1174',
      cancelButtonColor: '#3a3a3a',
      confirmButtonText: 'Eliminar'
    }).then((resultmodal) => {
      if (resultmodal.isConfirmed) {
        this.resumeService.deleteResume(resumeId).subscribe({
          next: res => {
            Swal.fire({
              title: 'Eliminado',
              text: 'El curriculum se eliminó correctamente.',
              icon: 'success',
              confirmButtonColor: '#0d1174'
            });
            this.resumes.update(resumes => resumes.filter(resume => resume.id !== resumeId));
          }, error: res => {
            Swal.fire({
              title: 'Error',
              text: 'Ocurrió un error al eliminar el curriculum.',
              icon: 'error',
              confirmButtonColor: '#d33'
            });
          }
        })
      } else {
      }
    });
  }

  editResume(resume: Resume){
    this.router.navigate(['/candidates', 'cv', resume.id]);
  }

  viewResume(resume: Resume){
    this.router.navigate(['/candidates', 'cv-preview', resume.id]);
  }

}
